<template>
  <div class="schedule-page page-wrapper">
    <div class="page-header">
      <div class="container">
        <h1 class="page-title">大会日程</h1>
        <p class="page-subtitle">Conference Schedule</p>
      </div>
    </div>

    <div class="page-content">
      <div class="container">
        <!-- 日期切换 -->
        <div class="day-tabs">
          <div 
            v-for="(day, index) in days" 
            :key="index"
            class="day-tab"
            :class="{ 'active': activeDay === index }"
            @click="activeDay = index"
          >
            <div class="tab-day">第{{ index + 1 }}天</div>
            <div class="tab-info">
              <span class="tab-date">{{ day.date }}</span>
              <span class="tab-weekday">{{ day.weekday }}</span>
            </div>
          </div>
        </div>

        <!-- 日程内容 -->
        <div class="schedule-wrapper">
          <div class="schedule-list">
            <div 
              v-for="(item, index) in currentSchedule" 
              :key="index" 
              class="schedule-item"
              :class="[item.type, { 'expanded': expandedItem === index }]"
            >
              <div class="item-time">
                <div class="time-start">{{ formatTime(item.start_time) }}</div>
                <div class="time-divider"></div>
                <div class="time-end">{{ formatTime(item.end_time) }}</div>
              </div>
              
              <div class="item-content" @click="toggleExpand(index)">
                <div class="content-header">
                  <div class="content-type" v-if="item.type !== 'normal'">
                    <span v-if="item.type === 'keynote'" class="type-keynote">主旨演讲</span>
                    <span v-else-if="item.type === 'break'" class="type-break">茶歇</span>
                    <span v-else-if="item.type === 'lunch'" class="type-lunch">用餐</span>
                  </div>
                  <h3 class="content-title">{{ item.title }}</h3>
                </div>
                
                <div class="content-meta">
                  <div v-if="item.speaker" class="meta-item">
                    <i class="el-icon-user"></i>
                    <span>{{ item.speaker }}</span>
                    <span v-if="item.speaker_title" class="speaker-title">{{ item.speaker_title }}</span>
                  </div>
                  <div v-if="item.location" class="meta-item">
                    <i class="el-icon-location-outline"></i>
                    <span>{{ item.location }}</span>
                  </div>
                </div>

                <div v-if="item.description" class="content-desc">
                  {{ item.description }}
                </div>

                <div v-if="item.description" class="expand-icon">
                  <i :class="expandedItem === index ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scheduleApi } from '@/api'

export default {
  name: 'Schedule',
  data() {
    return {
      activeDay: 0,
      expandedItem: null,
      loading: false,
      days: [],
      scheduleData: []
    }
  },
  computed: {
    currentSchedule() {
      return this.scheduleData[this.activeDay] || []
    }
  },
  created() {
    this.fetchSchedule()
  },
  methods: {
    formatTime(time) {
      if (!time) return ''
      return time.substring(0, 5)
    },
    formatDate(dateStr) {
      if (!dateStr) return { date: '', weekday: '' }
      const date = new Date(dateStr)
      console.log(date, 'date')
      const weekDays = ['周日', '周一', '周二', '周三', '周四', '周五', '周六']
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const weekday = weekDays[date.getDay()]
      return {
        date: `${year}年${month}月${day}日`,
        weekday
      }
    },
    toggleExpand(index) {
      if (this.expandedItem === index) {
        this.expandedItem = null
      } else {
        this.expandedItem = index
      }
    },
    async fetchSchedule() {
      this.loading = true
      try {
        const res = await scheduleApi.getList(1)
        if (res.data && res.data.length > 0) {
          // 数据已按天分组，每天有schedules数组
          this.days = res.data.map(dayData => {
            const formatted = this.formatDate(dayData.date)
            return {
              date: formatted.date,
              weekday: formatted.weekday
            }
          })
          this.scheduleData = res.data.map(dayData => {
            return (dayData.schedules || []).map(item => ({
              start_time: item.start_time,
              end_time: item.end_time,
              title: item.title,
              description: item.description || '',
              speaker: item.speaker || '',
              speaker_title: item.speaker_title || '',
              location: item.location || '',
              type: item.type || 'normal'
            }))
          })
        } else {
          this.useDefaultData()
        }
      } catch (error) {
        console.error('获取日程失败:', error)
        this.useDefaultData()
      } finally {
        this.loading = false
      }
    },
    useDefaultData() {
      this.days = [
        { date: '2025年3月15日', weekday: '周六' },
        { date: '2025年3月16日', weekday: '周日' }
      ]
      this.scheduleData = []
    }
  }
}
</script>

<style lang="scss" scoped>
.schedule-page {
  background: #f8f9fc;
}

.day-tabs {
  display: flex;
  justify-content: center;
  gap: 24px;
  margin-bottom: 50px;
}

.day-tab {
  background: #fff;
  border-radius: 16px;
  padding: 24px 48px;
  cursor: pointer;
  transition: all 0.3s;
  text-align: center;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  border: 2px solid transparent;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 10px 30px rgba(26, 35, 126, 0.1);
  }

  &.active {
    background: linear-gradient(135deg, #1a237e 0%, #3949ab 100%);
    color: #fff;
    border-color: transparent;

    .tab-day {
      color: #ffd700;
    }

    .tab-weekday {
      color: rgba(255, 255, 255, 0.8);
    }
  }

  .tab-day {
    font-size: 24px;
    font-weight: 700;
    color: #1a237e;
    margin-bottom: 8px;
  }

  .tab-info {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .tab-date {
      font-size: 15px;
    }

    .tab-weekday {
      font-size: 13px;
      color: #999;
    }
  }
}

.schedule-list {
  max-width: 900px;
  margin: 0 auto;
}

.schedule-item {
  display: flex;
  gap: 30px;
  margin-bottom: 20px;
  position: relative;

  &::before {
    content: '';
    position: absolute;
    left: 85px;
    top: 30px;
    bottom: -20px;
    width: 2px;
    background: #e0e3f0;
  }

  &:last-child::before {
    display: none;
  }

  &.keynote {
    .item-content {
      background: linear-gradient(135deg, rgba(26, 35, 126, 0.05) 0%, rgba(124, 77, 255, 0.05) 100%);
      border-left: 4px solid #1a237e;
    }
  }

  &.break, &.lunch {
    .item-content {
      background: #f5f5f5;
      opacity: 0.8;
    }

    .content-title {
      color: #666;
    }
  }
}

.item-time {
  width: 70px;
  text-align: center;
  flex-shrink: 0;
  position: relative;
  z-index: 1;

  .time-start, .time-end {
    font-size: 16px;
    font-weight: 600;
    color: #1a237e;
  }

  .time-divider {
    width: 20px;
    height: 2px;
    background: #7c4dff;
    margin: 8px auto;
  }

  .time-end {
    font-size: 14px;
    font-weight: 400;
    color: #999;
  }
}

.item-content {
  flex: 1;
  background: #fff;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition: all 0.3s;
  position: relative;

  &:hover {
    box-shadow: 0 8px 25px rgba(26, 35, 126, 0.1);
  }
}

.content-header {
  margin-bottom: 12px;
}

.content-type {
  margin-bottom: 8px;

  span {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
  }

  .type-keynote {
    background: linear-gradient(135deg, #ffd700, #ffec8b);
    color: #1a237e;
  }

  .type-break, .type-lunch {
    background: #f0f0f0;
    color: #666;
  }
}

.content-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a237e;
}

.content-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;

  .meta-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    color: #666;

    i {
      color: #7c4dff;
    }

    .speaker-title {
      color: #999;
      margin-left: 8px;

      &::before {
        content: '|';
        margin-right: 8px;
        color: #ddd;
      }
    }
  }
}

.content-desc {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px dashed #eee;
  font-size: 14px;
  color: #666;
  line-height: 1.8;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s;
}

.expanded .content-desc {
  max-height: 200px;
}

.expand-icon {
  position: absolute;
  right: 24px;
  top: 24px;
  color: #999;
}

.schedule-download {
  text-align: center;
  margin-top: 50px;
}

@media screen and (max-width: 768px) {
  .day-tabs {
    flex-direction: column;
    align-items: stretch;
    gap: 12px;
  }

  .day-tab {
    padding: 16px 24px;
    display: flex;
    align-items: center;
    gap: 16px;

    .tab-day {
      font-size: 20px;
      margin-bottom: 0;
    }

    .tab-info {
      flex-direction: row;
      gap: 8px;
    }
  }

  .schedule-item {
    flex-direction: column;
    gap: 10px;
    padding-left: 20px;

    &::before {
      left: 8px;
      top: 0;
    }
  }

  .item-time {
    width: auto;
    display: flex;
    align-items: center;
    gap: 10px;

    .time-divider {
      width: 10px;
      margin: 0;
    }
  }

  .content-meta {
    flex-direction: column;
    gap: 8px;

    .meta-item .speaker-title {
      display: block;
      margin-left: 0;

      &::before {
        display: none;
      }
    }
  }
}
</style>
